<template>
  <div class="app-page">
    <slot/>
    <br>
    <br>
    <br>
    <section class="app-max-width my-10 max-w-2xl m-auto space-y-3">
      <NuxtPage/>
    </section>
    <br>
    <br>
    <br>
  </div>
</template>
